import { useState } from 'react';
import { ChevronDown, GripVertical } from 'lucide-react';
import { SubcoLogo, TagChip } from '../../components/subco/SubcoBits';

// Taşeron sekmesi: subco başlığı altında bağlı çalışanlar; sürüklenince normal çalışan ataması olur.
export function SubcoGroup({ group, onDragStart, onTapEmp, selectedEmpId }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="rounded-lg border border-amber-200 dark:border-amber-800 overflow-hidden" data-testid={`planning-subco-group-${group.id}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-2 py-1.5 bg-amber-50 dark:bg-amber-900/20 text-left" data-testid={`planning-subco-group-toggle-${group.id}`}>
        <SubcoLogo subco={group} />
        <span className="flex-1 min-w-0 truncate text-xs font-black text-amber-900 dark:text-amber-100">{group.name}</span>
        <span className="text-[10px] font-bold text-amber-700">{group.employees.length}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-amber-700 transition-transform ${open ? '' : '-rotate-90'}`} />
      </button>
      {open && group.employees.length === 0 && (
        <p className="px-2 py-2 border-t border-amber-100 dark:border-amber-900/40 text-[10px] text-slate-400" data-testid={`planning-subco-group-empty-${group.id}`}>
          Bağlı çalışan yok — Kullanıcılar ekranından bu subco'ya çalışan ekleyin.
        </p>
      )}
      {open && group.employees.map((e) => (
        <div key={e.id} draggable onDragStart={(ev) => onDragStart(ev, e)} onClick={() => onTapEmp?.(e)}
          className={`group flex items-center gap-2 px-2 py-1.5 border-t border-amber-100 dark:border-amber-900/40 cursor-grab active:cursor-grabbing transition-colors ${selectedEmpId === e.id ? 'bg-sky-50 dark:bg-sky-900/30' : 'hover:bg-amber-50/60 dark:hover:bg-amber-900/10'}`}
          data-testid={`planning-subco-emp-${e.id}`}>
          <GripVertical className="h-3.5 w-3.5 text-slate-300 group-hover:text-amber-500 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-slate-700 dark:text-slate-200 truncate">{e.full_name}</p>
            <p className="text-[10px] text-slate-400 truncate">{e.firm_name || ''}{e.current_vehicle_plate ? ` · ${e.current_vehicle_plate}` : ''}</p>
          </div>
          {(e.tags || []).map((t) => <TagChip key={t} tag={t} active />)}
        </div>
      ))}
    </div>
  );
}
